import { updateField } from 'vuex-map-fields';

export default {
    updateField,

    updateAttr(state, payload) {
        state[payload.key] = payload.value;
    },

    set(state, payload) {
        Object.assign(state, payload);
    },

    updateTags(state, payload) {
        state.tags = payload.tags;
        state.media.tags = payload.active_tags;
    },

    updateFolders(state, payload) {
        state.folders = payload.folders;
        state.media.folders = payload.active_folders;
    },

    updateGroupName(state, payload) {
        state.media.groupName = payload.groupName;
    },

    updateGroupLabel(state, payload) {
        state.media.groupLabel = payload.groupLabel;
    },

    updateGroupImage(state, payload) {
        state.media.groupImage = payload.groupImage;
    },

    updateMedia(state, payload) {
        Object.assign(state.media, payload);
    },

    updateCostSplits(state, payload) {
        state.media.cost_splits = payload;
    },

    updateInitMedia(state, payload) {
        Object.assign(state.initMedia, payload);
    },

    updateAllowedComarketerUserTypes(state, payload) {
        state.media.allowed_comarketer_user_types = payload.allowed_comarketer_user_types;
    },

    setFormRef(state, payload) {
        state.formRef = payload;
    },

    clearOrgSettings(state) {
        state.media.allow_access = null;
        state.media.approval_flow_id = null;
        state.media.allowed_comarketer_user_types = [];
        state.media.allow_comarketer_access = null;
        state.media.org_cost_share_percent = null;
        state.media.org_cost_share_user_id = null;
        state.media.auto_pay_org_share = null;
        state.media.tags = [];
        state.media.folders = [];
        state.media.groupName = [];
        state.media.groupLabel = [];
    },

    updateOrgSettings(state, payload) {
        state.media.allow_access = payload.allow_access;
        state.media.approval_flow_id = payload.approval_flow_id;
        state.media.allowed_comarketer_user_types = payload.allowed_comarketer_user_types;
        state.media.allow_comarketer_access = payload.allow_comarketer_access;
        state.media.org_cost_share_percent = payload.org_cost_share_percent;
        state.media.org_cost_share_user_id = payload.org_cost_share_user_id;
        state.settings.auto_pay_available = payload.auto_pay_available;
        state.media.auto_pay_org_share = payload.auto_pay_org_share;
        state.settings.cost_splits = payload.cost_splits;
        state.media.cost_split_id = payload.cost_split_id;
    },

    refreshMarkupImage(state) {
        let timeIndex = state.media.markup_image_url.indexOf('?');
        let simpleUrl = state.media.markup_image_url;
        if (timeIndex != -1) {
            simpleUrl = simpleUrl.substring(0, timeIndex);
        }
        state.media.markup_image_url = `${simpleUrl}?${Date.now()}`;
    },
}